module.exports = __webpack_public_path__ + "static/media/29a Knee on Belly.4ea5af28.jpg";